<form autocomplete="off" class="p-0" novalidate [formGroup]="AnswerSheetForm">
  <div class="main-content side-content pt-0 ml-0">
    <div class="main-container container-fluid">
      <div class="inner-body">
        <div class="row row-sm add-form">
          <div class="col-lg-12 col-md-12">
            <div class="card custom-card">
              <div class="card-body pb-0">
                <div class="col-md-12 prpl">

                  <!-- Header -->
                  <div class="row align-items-center">
                    <div class="col-md-6 prpl">
                      <div class="d-flex align-items-center">
                        <img alt="Logo" src="../../assets/img/attendance.png" class="mh-45px pb-2">
                        <p class="mb-1">
                          <span class="main-content-label"><b>Buffer Student Answer Sheet Code Entry</b></span><br>
                          <span class="text-muted card-sub-title mb-0">
                            Select Session / Course / Exam and click Get List
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <hr class="mt-2">

                  <!-- Dropdowns -->
                  <div class="row clearfix mt-2">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Session</mat-label>
                          <mat-select #select232 placeholder="Session" class="colorblack"
                                      formControlName="SessionId">
                            <mat-select-filter *ngIf="select232.focused"
                              [placeholder]="'Filter'" [displayMember]="'SnName'"
                              [array]="sessionList"
                              (filteredReturn)="SessionFilterList = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of SessionFilterList"
                                        [value]="item.SnNo" (click)="getCourse(item)">
                              {{ item.SnName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="AnswerSheetForm.get('SessionId').hasError('required')">
                            Session is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Course</mat-label>
                          <mat-select #select55 class="colorblack" formControlName="course">
                            <mat-select-filter *ngIf="select55.focused"
                              [placeholder]="'Filter'" [displayMember]="'CoName'"
                              [array]="CourseList"
                              (filteredReturn)="filteredListCourse = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListCourse"
                                        [value]="item.CoCode" (click)="getExamList(item)">
                              {{ item.CoCode }} - {{ item.CoName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="AnswerSheetForm.get('course').hasError('required')">
                            Course is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Exam</mat-label>
                          <mat-select #select2398 placeholder="Exam" formControlName="EmId">
                            <mat-select-filter *ngIf="select2398.focused"
                              [placeholder]="'Filter'" [displayMember]="'EmName'"
                              [array]="examList"
                              (filteredReturn)="filteredListExam = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListExam"
                                        [value]="item.EmId"
                                        (click)="onExamSelected(item)">
                              {{ item.EmCoCode }}-{{ item.EmName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="AnswerSheetForm.get('EmId').hasError('required')">
                            Exam is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Get List button -->
                    <div class="col-sm-3">
                      <div class="form-group d-flex align-items-center" style="height: 100%;">
                        <button type="button"
                                class="btn btn-primary btn-icon-text"
                                style="margin-top: 8px;"
                                [disabled]="loading"
                                (click)="getBarcodeList(1)">
                          <i class="fas fa-list mr-2"></i>
                          Get List
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Info banners -->
                  <!-- <div class="row align-items-center">
                    <div class="col-sm-12">
                      <div *ngIf="message" class="mb-3">
                        <p style="color: green;">
                          <b><i class="fas fa-check-circle mr-2"></i>{{ message }}</b>
                        </p>
                      </div>
                      <div *ngIf="closeMessage" class="mb-3">
                        <p style="color: red;">
                          <b><i class="fas fa-lock mr-2"></i>{{ closeMessage }}</b>
                        </p>
                      </div>
                    </div>
                  </div> -->

                  <!-- Barcode list -->
                  <div *ngIf="Table && barcodeList.length > 0"
                       class="table-responsive mt-4">
                    <table class="table table-bordered text-center"
                           style="min-width: 1000px;">
                      <thead class="text-center">
                        <tr>
                          <th style="width: 60px;">Sr.No</th>
                          <th style="min-width: 90px;">Seat No</th>
                          <th style="min-width: 90px;">PRN No</th>
                          <th style="min-width: 130px;">Exam Date</th>
                          <th style="min-width: 150px;">Subject</th>
                          <!-- <th style="min-width: 130px;">Paper</th> -->
                          <th style="min-width: 220px;">Buffer Answer Sheet Code</th>
                          <th style="width: 120px;">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of barcodeList; let i = index">
                          <td style="vertical-align: middle;">
                            {{ (currentPage - 1) * pageSize + i + 1 }}
                          </td>
                          <td style="vertical-align: middle; padding: 8px;">
                            {{ item.S_NO }}
                          </td>
                          <td style="vertical-align: middle; padding: 8px;">
                            {{ item.P_NO }}
                          </td>
                          <td style="vertical-align: middle; padding: 8px;">
                            {{ item.Examdate | date:'dd-MM-yyyy' }}
                          </td>
                          <td style="vertical-align: middle; padding: 8px;">
                            {{ item.Subject }}
                          </td>
                          <!-- <td style="vertical-align: middle; padding: 8px;">
                            {{ item.PAPER }}
                            <span *ngIf="item.PaperNo">({{ item.PaperNo }})</span>
                          </td> -->
                          <td style="vertical-align: middle; padding: 8px;">
                            <mat-form-field appearance="outline" class="w-100">
                              <input matInput
                                     placeholder="Enter Answer Sheet Code"
                                     [(ngModel)]="item.AnswerSheetCode"
                                     [ngModelOptions]="{standalone: true}"
                                     maxlength="20">
                            </mat-form-field>
                          </td>
                          <td style="vertical-align: middle; padding: 8px;">
                            <button type="button"
                                    class="btn btn-sm btn-primary"
                                    [disabled]="item._saving"
                                    (click)="saveRow(item)">
                              <span *ngIf="!item._saving">
                                <i class="fas fa-save mr-1"></i>
                                {{ item._saved ? 'Save' : 'Save' }}
                              </span>
                              <span *ngIf="item._saving">
                                <i class="fas fa-spinner fa-spin mr-1"></i>Saving...
                              </span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <mat-paginator *ngIf="Table && totalItems > 0"
                                 [length]="totalItems"
                                 [pageSize]="pageSize"
                                 [pageSizeOptions]="pageSizeOptions"
                                 [pageIndex]="currentPage - 1"
                                 (page)="onPageChange($event)">
                  </mat-paginator>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>